import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Segment } from '~src/interfaces/segment.interface';

import { SurveySubjectTypes } from '~src/interfaces/surveys.interfaces';
import { getNameOfSegment } from '~src/services/getNameOfSegment';
import SvgIcon from '~src/shared/SvgIcon';
import HoverInfoIcon from '~src/shared/tooltips/HoverInfoIcon';
import RowTitle from '~src/modules/heatmap/components/table/row/RowTitle';
import { SegmentAggregation } from '~src/interfaces/heatmap.interface';

import { ColumnWrapper, MasterRowContainer, BackLink } from './entityColumn.sc';

export interface EntityColumnRow {
  segment: Segment;
  hasAggregations: boolean;
}

interface Props {
  topRow?: EntityColumnRow;
  segments: EntityColumnRow[];
  selectGroup: (group: string | null) => void;
  selectedGroup?: EntityColumnRow;
  aggrBySegmentId: Record<string, SegmentAggregation>;
  surveyType: SurveySubjectTypes;
}

const EntityColumn: FC<Props> = (props) => {
  const [t] = useTranslation();

  const segmentRow = (item: EntityColumnRow) => (
    <RowTitle
      clickable={props.surveyType !== SurveySubjectTypes.Groups}
      hasAggr={item.hasAggregations}
      key={item.segment.id}
      segment={item.segment}
      select={props.selectGroup}
      noData={!props.aggrBySegmentId[item.segment.id]}
    />
  );

  const backClick = () => {
    props.selectGroup(null);
  };

  const masterSegmentRow = (item: EntityColumnRow) => (
    <MasterRowContainer>
      <BackLink onClick={backClick}>
        <SvgIcon name="iconArrow" width={25} />
        <span>{getNameOfSegment(t, item.segment)}</span>&nbsp;&nbsp;
        <HoverInfoIcon infoText={t('x.compare.user_count_info')} />
      </BackLink>
    </MasterRowContainer>
  );

  return (
    <ColumnWrapper>
      {props.topRow && segmentRow(props.topRow)}
      {props.selectedGroup && masterSegmentRow(props.selectedGroup)}
      {props.segments.map(segmentRow)}
    </ColumnWrapper>
  );
};

export default EntityColumn;
